import { STANDARD_BRANCH } from '@festina-life/api'

import { useIsPersonaEditor } from '../uiModels/useIsPersonaEditor'
import { useOperationsContext } from '../workspace/operationsContext'
import { useBaseBranchWorkspaces } from './useBaseBranchWorkspaces'

export const useIsInlineEditingAvailable = () => {
  const { workspaceKey, branchKey } = useOperationsContext()
  const branchWorkspaces = useBaseBranchWorkspaces(branchKey)
  const isEditor = useIsPersonaEditor()
  return (
    isEditor &&
    branchKey &&
    branchKey.name !== STANDARD_BRANCH &&
    (!!workspaceKey || branchWorkspaces.length <= 1)
  )
}
